import { Typography, Row, Col }  from 'antd'
import Breakpoint from '../../enums/breakpoint.enum.js'
import useWidth from '../../hooks/useWidth.hook.js'

const { Text, Paragraph } = Typography

export const CleerlyConfirm = ({ flow }) => {
  const width = useWidth()

  const instructions = [{
    sections: [
      {
      title: 'Schedule Your Scan',
      description: <>An Instalab physician will review your details as legally required. Once approved, our concierge team will email you to help schedule your CCTA at {flow?.facility?.name}.</>
    }, 
  ]},
  
  flow?.user?.hasRHROver60 !== 'no' && {
    sections: [
      {
      
          title: 'Prepare with Beta Blocker (If Needed)',
          description: <>If your resting heart rate is typically above 60 bpm, you may be prescribed a beta blocker, which we’ll ship to you. It helps slow your heart rate for clearer imaging. Take it 12 hours and again 1 hour before your scan.</>      
      }
    ]
  }, 
  {
    sections: [  {
      title: 'Complete Your Scan',
      description: <>Visit {flow?.facility?.name} for your CCTA. The appointment typically takes about an hour.</>
    }]
  }, 
  {
    sections: [{
      title: 'View Results & Report',
      description: <>Once Cleerly analyzes the images, we’ll email your results along with a detailed report. This usually happens 1–2 business days after your scan.</>
    }]
  }].filter(Boolean)

  return (
    <div className="prescription-approval">

      <div style={{fontWeight:600, marginBottom:10}}>Next steps for CCTA with Cleerly:</div> 
      {instructions?.length > 0 && (
        <div className="instruction-list">
          {instructions.map(({ sections }, instructionIndex) => (
            <div 
              key={`instruction-${instructionIndex}`} 
              className="instruction-item"
            >
              <Row>
                <Col
                  style={{
                    width: width > Breakpoint.SM ? 80 : '100%',
                    marginBottom: width > Breakpoint.SM ? 0 : 10
                  }}
                >
                  <Text className="instruction-index">
                    Step {instructionIndex+1}
                  </Text>
                </Col>

                <Col
                  style={{
                    width: width > Breakpoint.SM ? 'calc(100% - 80px)' : '100%'
                  }}
                >
                  {sections.map(({ title, description }, sectionIndex) => (
                    <div 
                      key={`section-${instructionIndex}-${sectionIndex}`} 
                      className="section-item"
                    >
                      <Text className="section-title">
                        {title}
                      </Text>
                      <Paragraph className="section-description">
                        {description}
                      </Paragraph>
                    </div>
                  ))}
                  </Col>
              </Row>
            </div>
          ))}
        </div>
      )}

{/* 
      <Button
        className="question-btn"
        onClick={() => window.FrontChat("show")}
      >
        I have a question?
      </Button>

      <LatestPosts /> */}
    </div>
  )
}

